module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/4-1f1a817440d8f8d7598284a7e80e829e.jpg";